"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "the-layout" };
const _hoisted_2 = ["src"];
const vue_basic_ui_1 = require("@xenodrive/vue-basic-ui");
exports.default = (0, vue_1.defineComponent)({
    __name: 'BssMovementLayoutChanger',
    props: /*@__PURE__*/ (0, vue_1.mergeModels)({
        list: { default: () => [1, 2] }
    }, {
        "modelValue": {},
        "modelModifiers": {},
    }),
    emits: ["update:modelValue"],
    setup(__props) {
        const layout = (0, vue_1.useModel)(__props, "modelValue");
        const props = __props;
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(vue_basic_ui_1.Radio), {
                modelValue: layout.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((layout).value = $event))
            }, {
                default: (0, vue_2.withCtx)(() => [
                    (0, vue_2.createElementVNode)("div", _hoisted_1, [
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(props.list, (i) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(vue_basic_ui_1.RadioItem), {
                                key: i,
                                value: i
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.Button), null, {
                                        default: (0, vue_2.withCtx)(() => [
                                            (0, vue_2.createElementVNode)("img", {
                                                style: { "height": "2rem" },
                                                src: layout.value === i
                                                    ? `/assets/img/movement/layout_types/icon_layout_type_${i}.active.png`
                                                    : `/assets/img/movement/layout_types/icon_layout_type_${i}.inactive.png`
                                            }, null, 8, _hoisted_2)
                                        ]),
                                        _: 2
                                    }, 1024)
                                ]),
                                _: 2
                            }, 1032, ["value"]));
                        }), 128))
                    ])
                ]),
                _: 1
            }, 8, ["modelValue"]));
        };
    }
});
